import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React, {useEffect, useState} from 'react';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import {ezprOrange, useOlympeProperty} from './_helpers';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Avatar from '@mui/material/Avatar';

/**
 * This brick display an orange bubble with the user's initial in the middle, and trigger the on click event when clicking on it
 */
export default class UserBubble extends ReactBrick {
    /**
     * @param {BrickContext} $
     * @return {function(*): *}
     */
    static getReactComponent($) {
        return () => {
            const [loading, setLoading] = useOlympeProperty($, 'Loading', true);
            const bearerToken = useProperty($, 'Bearer token');
            const [img, setImg] = useState(null);

            const fullName = localStorage.getItem('userFullName') || '';
            const userEmail = localStorage.getItem('userEmail') || '';
            const initials = fullName
                .split(' ')
                .slice(0, 2)
                .map((name) => name[0].toUpperCase())
                .join('');

            useEffect(async () => {
                if (
                    !userEmail ||
                    userEmail === 'test.user@nestle.test' ||
                    !bearerToken
                ) {
                    return;
                }

                const fetchPhoto = async () => {
                    try {
                        const response = await fetch(
                            `https://graph.microsoft.com/v1.0/users/${userEmail}/photo/$value`,
                            {
                                headers: {
                                    'ConsistencyLevel': 'eventual',
                                    'Authorization': bearerToken,
                                },
                            },
                        );
                        if (!response.ok) {
                            console.error('Failed to fetch profile picture');
                            setImg(null);
                            return;
                        }
                        const blob = await response.blob();
                        setImg(URL.createObjectURL(blob));
                    } catch (error) {
                        console.error('Error fetching profile picture:', error);
                        setImg(null);
                    }
                };

                await fetchPhoto();
            }, [userEmail, bearerToken]);

            const handleClick = () => {
                setLoading(true);
                $.trigger('On Click');
            };

            return (
                <Tooltip
                    title="User defaults and settings."
                    placement="top"
                    enterDelay={700}
                    leaveDelay={0}
                >
                    <div
                        className="user-bubble-background"
                        data-cy={'user-bubble'}
                        onClick={handleClick}
                    >
                        <div className="user-bubble-circle" style={{backgroundColor: img ? 'transparent' : '#ffd27a', position: 'relative'}}>
                            {img ?
                                <Avatar alt={fullName} src={img}
                                    sx={{backgroundColor: 'transparent', width: 32, height: 32, opacity: loading ? 0.25 : 1}} /> :
                                <span className="user-bubble-text" style={{opacity: loading ? 0.25 : 1}}>{initials}</span>
                            }
                            {loading && (
                                <CircularProgress
                                    className="user-bubble-loading"
                                    size={18}
                                />
                            )}
                        </div>

                        {fullName && (
                            <span className="user-bubble-fullname">
                                {fullName}
                            </span>
                        )}
                        <ArrowDropDownIcon className="user-bubble-icon"/>
                    </div>
                </Tooltip>
            );
        };
    }
}

registerBrick('0189d53c2e2f3c669528', UserBubble);
